import { Reducer } from "redux";
import navigationTypes, {
  NavigationState,
  NavigationActionsTypes,
  SetNavigationItemsAction,
} from "./types";

export const initialState: NavigationState = {
  items: [
    {
      id: "7c35aec0-e730-4a70-bfba-b5efcfd335c5",
      label: "Admin",
      uri: "/admin/",
      isVisible: true,
      tooltip: "",
      sortOrder: 10,
      newWindow: false,
      __children: [
        {
          id: "1bdd77ea-0f9e-42fa-b4f1-13841ba022da",
          label: "Navigation",
          uri: "/admin/navigation/",
          isVisible: true,
          tooltip: "",
          sortOrder: 1,
          newWindow: false,
          __children: [],
        },
        {
          id: "f149f7e1-f6aa-45ed-b25e-f940f2620837",
          label: "Privileges",
          uri: "/admin/privileges",
          isVisible: true,
          tooltip: "",
          sortOrder: 2,
          newWindow: false,
          __children: [],
        },
        {
          id: "6bb378ed-cc57-46ec-bb44-8295079fb610",
          label: "Resources",
          uri: "/admin/resources/",
          isVisible: true,
          tooltip: "",
          sortOrder: 3,
          newWindow: false,
          __children: [],
        },
        {
          id: "16415fe8-a6d9-467f-aed2-45c104c086b4",
          label: "Roles",
          uri: "/admin/roles/",
          isVisible: true,
          tooltip: "",
          sortOrder: 4,
          newWindow: false,
          __children: [],
        },
        {
          id: "37cf78a7-87db-4ec3-a6be-950917c29dcc",
          label: "Users",
          uri: "/admin/users/",
          isVisible: true,
          tooltip: "",
          sortOrder: 5,
          newWindow: false,
          __children: [],
        },
      ],
    },
  ],
};

const reducer: Reducer<NavigationState, NavigationActionsTypes> = (
  state = initialState,
  action
) => {
  const stateCopy: NavigationState = JSON.parse(JSON.stringify(state));
  switch (action.type) {
    case navigationTypes.GET_NAVIGATION_ITEMS_SUCCESS: {
      const payload = (action as SetNavigationItemsAction).payload;
      return { ...stateCopy, payload };
    }
    default:
      return stateCopy;
  }
};

export default reducer;
